export default {
  shipping: '0',
  billing: '1',
  store: '2'
}
